export const convertToNewFormat = async (messages) => {
  const result = {
    user_msg: {
      content: {},
      timestamp: getCurrentTimestamp(),
      content_type: "generic",
    },
    system_msg: {
      content: {},
      timestamp: getCurrentTimestamp(),
      content_type: "generic",
    },
  };

  messages.forEach((msg, index) => {
    if (msg.role === "user") {
      result.user_msg.content[index] = msg.content;
    } else if (msg.role === "assistant") {
      result.system_msg.content[index - 1] = msg.content;
    }
  });

  return result;
};

export const getCurrentTimestamp = () => {
  const date = new Date();
  return date.toISOString();
};

export const convertMessages = async (inputArray, module = "COACHING") => {
  if (inputArray.length === 0)
    return [
      { role: "system", content: "No Chat History Found On this Session" },
    ];
  // Initialize an empty array for the output
  const outputArray = [];

  // Loop through the input array
  await inputArray.forEach((item) => {
    // Extract role and content
    let { role, content } = item;
    if ((module === "RELATIONSHIPS" || module === "RELATIONSHIP_ADVICE") && role === "assistant") {
      try {
        content = JSON.parse(content);
        content = content?.question;
      } catch (error) {
        // leave content as-is if parsing fails
      }
    }
    if (content) {
      outputArray.push({
        role,
        content: content,
      });
    }
  });

  return outputArray;
};

export default convertMessages;
